import { render, staticRenderFns } from "./menu-layout.vue?vue&type=template&id=64b11d10&scoped=true"
import script from "./menu-layout.vue?vue&type=script&lang=js"
export * from "./menu-layout.vue?vue&type=script&lang=js"
import style0 from "./menu-layout.vue?vue&type=style&index=0&id=64b11d10&lang=less&scoped=true"
import style1 from "./menu-layout.vue?vue&type=style&index=1&id=64b11d10&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b11d10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b11d10')) {
      api.createRecord('64b11d10', component.options)
    } else {
      api.reload('64b11d10', component.options)
    }
    module.hot.accept("./menu-layout.vue?vue&type=template&id=64b11d10&scoped=true", function () {
      api.rerender('64b11d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu-layout.vue"
export default component.exports